import { ReactElement } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"

type Props = {
  title: string
  children: ReactElement
  count?: number
  icon?: IconDefinition
  subtitle?: string
}

const DashboardCard = ({ title, count, children, icon, subtitle }: Props): ReactElement => {
  return (
    <div className="bg-white border border-gray-100 border-solid rounded-xl shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-3">
          {!!icon && (
            <div className="bg-[var(--interactive-01)] rounded-lg p-1.5">
              <FontAwesomeIcon icon={icon} size="lg" className="text-white" />
            </div>
          )}

          <div>
            <p className="text-base font-bold text-gray-900">{title}</p>
            {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
          </div>
        </div>

        {!!count && (
          <div className="flex gap-3 items-center">
            <div className="text-xs rounded-full px-2.5 !py-1 bg-[var(--interactive-01)] text-white font-bold shadow-sm">
              {count}
            </div>
          </div>
        )}
      </div>

      {children}
    </div>
  )
}

export default DashboardCard
